import ReactDOM from 'react-dom';

export default function DatePickerPopperContainer({ children }) {
    if (!children) return null;
    return ReactDOM.createPortal(children, document.body);
}
